import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { routModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiService } from './common/API/api.service';
import { apiUrlComponent } from './common/api.url.component';
import { BackRestrict } from './common/backRestrict'
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { LayoutComponent } from './shared/layout/layout.component';
import { AlwaysAuthGuard } from './Services/auth.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {CommonService} from './Services/common.service';
import { AppDataService } from './Services/app-data-service';
import { ExcelService } from './common/API/excel.service';
import { PhoneModelExcelService } from './Services/excel.service';
import {FormsModule} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,

  ],
  imports: [
    BrowserModule,
    routModule, HttpModule, HttpClientModule, NgxSpinnerModule, BrowserAnimationsModule,FormsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    })
  ],
  exports: [

  ],
  providers: [ApiService, apiUrlComponent, AlwaysAuthGuard, BackRestrict,CommonService,ExcelService,
  AppDataService,PhoneModelExcelService,DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
